"use strict";
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import $ from "jquery";
import ApiService from "../services/api_service";
import FactorInvoicesService from "./factor_invoices_service";
import DataStoreService from "./data_store_service";
import uuid from "@lukeed/uuid";
import { createPusherInstance } from "./pusher_factory";
import { dequal } from "dequal/lite";
import { parseReviewPath } from "./flow_mode/flow_mode_review_helpers";
import { encodeDocumentReviewStartNextResponse_NextReview } from "./data/types/Pb";
function findTokenIndex(appState, token) {
  return appState.findIndex((_) => _.token == token);
}
function getPersonalChannelName(accountId, token) {
  return `presence-${PusherConfig.presenceChannelHost}-token-${token}-account-${accountId}`;
}
function createPersonalChannel(pusher, accountId, token) {
  return pusher.subscribe(getPersonalChannelName(accountId, token));
}
function waitForSubscription(channel) {
  return new Promise((res, rej) => {
    if (channel.subscribed) {
      res(channel);
      return;
    }
    channel.bind("pusher:subscription_succeeded", () => {
      res(channel);
    });
  });
}
function getOrCreatePersonalChannel(pusher, accountId, token, personalChannels) {
  let personalChannel = personalChannels[findTokenIndex(personalChannels, token)];
  if (personalChannel) return personalChannel.channel;
  personalChannel = createPersonalChannel(pusher, accountId, token);
  personalChannels.push({ token, channel: personalChannel });
  return waitForSubscription(personalChannel);
}
function splitByTokenState(appState, timeoutInterval) {
  const now = Date.now();
  return appState.reduce(
    (splits, state) => {
      const { at } = state;
      if (now - at < timeoutInterval) splits.alive.push(state);
      else splits.dead.push(state);
      return splits;
    },
    { alive: [], dead: [] }
  );
}
const fiveMinutesInMs = 1e3 * 60 * 5;
const PresenceService = function() {
  const instance = {
    logging: localStorage.getItem("HUBTRAN_PRESENCE_LOGGING"),
    appState: [],
    // where are all the other people?
    pageCurrentUserIsOn: null,
    // where am I?
    ready: false,
    user: null,
    pingFrequency: 1e3 * 60 * 2,
    // two minutes
    timeoutInterval: 1e3 * 60 * 3,
    // three minutes
    tabHiddenDisconnectInterval: 1e3 * 60 * 10,
    // ten minutes
    queuedAt: 0,
    appStateBatchTimeoutId: 0,
    $this: null,
    personalChannels: [],
    textEncoder: new TextEncoder(),
    token: void 0,
    pc: void 0,
    channel: void 0,
    notificationChannel: void 0,
    personalChannel: void 0,
    flushedAt: void 0,
    pingTimer: void 0,
    maybeElmApp: void 0,
    carrierId: void 0,
    waitForPresence: void 0,
    tabLastHiddenAt: 0,
    visibilityChangeHandler: void 0,
    startIfNeeded(user) {
      if (user && !this.user) {
        this.startForUser(user);
      }
    },
    startForUser(user) {
      this.$this = $(this);
      const PRESENCE_TOKEN = "presenceToken";
      const presenceToken = sessionStorage.getItem(PRESENCE_TOKEN) || uuid();
      sessionStorage.setItem(PRESENCE_TOKEN, presenceToken);
      this.log("In start for user");
      const channelName = [
        "presence",
        PusherConfig.presenceChannelHost,
        "account",
        user.account_id
      ].join("-");
      this.log("In start for user", channelName);
      const pc = createPusherInstance();
      this.pc = pc;
      this.channel = pc.subscribe(channelName);
      this.notificationChannel = pc.subscribe(PusherConfig.notificationChannel);
      const _a2 = user, { account: _ } = _a2, userWithoutAccount = __objRest(_a2, ["account"]);
      this.user = userWithoutAccount;
      this.token = presenceToken;
      this.user.token = this.token;
      const presenceInfoJSON = localStorage.getItem("presenceInfo");
      const presenceInfo = presenceInfoJSON ? JSON.parse(presenceInfoJSON) : { time: 0, state: [] };
      if (presenceInfo.state.length && Date.now() - presenceInfo.time < fiveMinutesInMs) {
        this.appState = splitByTokenState(
          presenceInfo.state,
          this.timeoutInterval
        ).alive;
        this.batchStateUpdate();
      } else {
        presenceInfo.state = [];
      }
      this.personalChannel = createPersonalChannel(
        pc,
        user.account_id,
        presenceToken
      );
      this.personalChannel.bind(
        "client-hubtran:receive_location",
        this.setOtherUsersCurrentLocation.bind(this)
      );
      this.channel.bind("pusher:subscription_succeeded", () => __async(this, null, function* () {
        this.ready = true;
        if (this.pageCurrentUserIsOn) {
          this.send(this.pageCurrentUserIsOn);
        }
        const hashedState = yield Promise.all(
          presenceInfo.state.map(this.convertStateToHash.bind(this))
        );
        this.channel.trigger("client-hubtran:user_signed_in", {
          token: presenceToken,
          state: hashedState
        });
      }));
      this.channel.bind(
        "client-hubtran:user_signed_in",
        this.sendMyCurrentLocation.bind(this)
      );
      this.channel.bind(
        "client-hubtran:user_moved_to",
        this.setOtherUsersCurrentLocation.bind(this)
      );
      this.channel.bind("client-hubtran:ping", this.pingReceived.bind(this));
      this.channel.bind(
        "client-hubtran:data_update",
        this.dataUpdate.bind(this)
      );
      this.channel.bind(
        "server-hubtran:factor_invoice_created",
        this.triggerInvoiceCreated.bind(this)
      );
      this.channel.bind(
        "server-hubtran:debtor_confirmation_delivered",
        this.debtorConfirmationDelivered.bind(this)
      );
      this.notificationChannel.bind(
        "server-hubtran:notification",
        (payload) => {
          this.notify(payload);
        }
      );
      this.pingTimer = window.setInterval(
        this.pingOthers.bind(this),
        this.pingFrequency
      );
      this.setupTabEngagementTracking();
    },
    batchStateUpdate() {
      const now = Date.now();
      this.queuedAt = this.queuedAt || now;
      this.flushedAt = this.flushedAt || 0;
      clearTimeout(this.appStateBatchTimeoutId);
      const timeSinceFlush = now - this.flushedAt;
      if (timeSinceFlush >= 1e3) {
        this.flushState();
      } else {
        this.appStateBatchTimeoutId = setTimeout(
          this.flushState.bind(this),
          1e3 - timeSinceFlush
        );
      }
    },
    flushState() {
      const now = Date.now();
      this.log("Flush state", {
        sinceQueuedAt: now - this.queuedAt,
        sinceFlushedAt: now - this.flushedAt
      });
      this.flushedAt = now;
      this.queuedAt = null;
      localStorage.setItem(
        "presenceInfo",
        JSON.stringify({ state: this.appState, time: now })
      );
      this.$this.trigger("presence_service:updated");
    },
    // @NOTE: Pusher has a limit of 10kb, so we're turning the path & token
    // into a base64 SHA hash to dramatically reduce the size of our payload
    convertStateToHash(_0) {
      return __async(this, arguments, function* ({ path, token }) {
        const msgUint8 = this.textEncoder.encode(JSON.stringify({ path, token }));
        const hashBuffer = yield crypto.subtle.digest("SHA-1", msgUint8);
        const hashB64 = btoa(String.fromCharCode(...new Uint8Array(hashBuffer)));
        return hashB64;
      });
    },
    registerElmApp(elmApp) {
      this.maybeElmApp = elmApp;
    },
    dataUpdate(data) {
      this.log("Got some data", data);
      DataStoreService.updateStores(data);
      if (this.maybeElmApp) {
        this.maybeElmApp.pushDataUpdate(data || {});
      }
    },
    debtorConfirmationDelivered(data) {
      this.log("debtor confirmation delivered", data);
      if (this.maybeElmApp) {
        this.maybeElmApp.pushDebtorConfirmationDelivered(data);
      }
    },
    triggerInvoiceCreated(data) {
      this.log("triggering invoice created", data);
      FactorInvoicesService.fetchWithID(data.factor_invoice_id).then((data2) => {
        $(instance).trigger("presence_service:invoiceCreated", [data2]);
      });
    },
    notify(message) {
      this.log("NOTIFICATION", message);
      $(ApiService).trigger("ApiService:alertError", [
        { message, details: null, type: "info" }
      ]);
    },
    setupTabEngagementTracking() {
      if (this.visibilityChangeHandler) {
        document.removeEventListener(
          "visibilitychange",
          this.visibilityChangeHandler
        );
      }
      this.visibilityChangeHandler = () => {
        if (document.hidden) {
          this.tabLastHiddenAt = Date.now();
        } else {
          this.tabLastHiddenAt = 0;
        }
      };
      document.addEventListener(
        "visibilitychange",
        this.visibilityChangeHandler
      );
    },
    reconnect() {
      this.log("Reconnecting to Pusher...");
      if (this.pingTimer) clearInterval(this.pingTimer);
      this.tabLastHiddenAt = 0;
      this.startForUser(this.user);
      this.log("\u{1F50C} PUSHER RECONNECTED SUCCESSFULLY \u{1F50C}");
    },
    pingOthers() {
      this.log("telling everybody I'm still here");
      this.log("cleaning up stale users");
      const timeSinceTabHidden = this.tabLastHiddenAt > 0 ? Date.now() - this.tabLastHiddenAt : 0;
      if (this.pageCurrentUserIsOn) {
        if (timeSinceTabHidden >= this.tabHiddenDisconnectInterval && document.hidden) {
          this.log("\u{1F6A8} TAB HAS BEEN HIDDEN TOO LONG - DISCONNECTING! \u{1F6A8}");
          this.pc.disconnect();
          if (this.pingTimer) clearInterval(this.pingTimer);
          const handleTabReturn = () => {
            if (!document.hidden) {
              document.removeEventListener("visibilitychange", handleTabReturn);
              this.reconnect();
            }
          };
          document.addEventListener("visibilitychange", handleTabReturn);
          return;
        }
      }
      const { alive, dead } = splitByTokenState(
        this.appState,
        this.timeoutInterval
      );
      dead.forEach(({ token }) => {
        const personalChannelIndex = findTokenIndex(
          this.personalChannels,
          token
        );
        const personalChannel = this.personalChannels[personalChannelIndex];
        if (personalChannel) {
          this.pc.unsubscribe(
            getPersonalChannelName(this.user.account_id, personalChannel.token)
          );
          this.personalChannels.splice(personalChannelIndex, 1);
        }
      });
      this.appState = alive;
      if (dead.length > 0) {
        this.log(`Removed ${dead.length} stale users`);
        this.batchStateUpdate();
      }
      this.channel.trigger("client-hubtran:ping", this.pageCurrentUserIsOn);
      this.sendPresenceToAudit(this.pageCurrentUserIsOn);
    },
    pingReceived(user) {
      this.log(
        `${user.userName} (${user.userId}/${user.token})
                told me they are still there`,
        user
      );
      const foundStateIndex = findTokenIndex(this.appState, user.token);
      if (foundStateIndex >= 0) {
        user.at = Date.now();
        this.appState[foundStateIndex] = user;
        localStorage.setItem(
          "presenceInfo",
          JSON.stringify({ state: this.appState, time: user.at })
        );
        this.log(
          `updated lastPingAt to ${/* @__PURE__ */ new Date()} for user ${user.userName} (${user.userId}/${user.token})`
        );
      } else if (!this.user.token === user.token) {
        this.log(
          `DID NOT FIND STATE for user ${user.userName} (${user.userId}/${user.token})`
        );
        this.setOtherUsersCurrentLocation(user);
      }
    },
    notifyMonitor(message, data) {
      $.post("/pusher/monitor", { message, data });
    },
    // user signs in, kicks off client-hubtran:user_present with user id
    // other users get client-hubtran:user_present, broadcast their current
    // location on client-hubtran:users_current_location
    // user gets everybody's current location and adds them to appState
    // setOtherUsersCurrentLocation
    sendMyCurrentLocation(_0) {
      return __async(this, arguments, function* ({ token, state }) {
        if (this.pageCurrentUserIsOn) {
          const hasState = state && state.length > 0;
          this.log("Has state?", hasState);
          if (!hasState) return this.sendToPersonalChannel(this.user, token);
          const hash = yield this.convertStateToHash(this.pageCurrentUserIsOn);
          const hasHash = state.includes(hash);
          this.log("Has my hash?", hasHash);
          if (!hasHash) return this.sendToPersonalChannel(this.user, token);
        }
      });
    },
    sendToPersonalChannel(user, token) {
      return __async(this, null, function* () {
        this.log("sending my location...", this.pageCurrentUserIsOn);
        const personalChannel = yield getOrCreatePersonalChannel(
          this.pc,
          user.account_id,
          token,
          this.personalChannels
        );
        personalChannel.trigger(
          "client-hubtran:receive_location",
          this.pageCurrentUserIsOn
        );
      });
    },
    setOtherUsersCurrentLocation(payload) {
      this.log("received... ", payload);
      if (this.user.token == payload.token) {
        this.log("received myself; ignoring");
        return;
      }
      const prevPayloadIndex = findTokenIndex(this.appState, payload.token);
      const prevPayload = this.appState[prevPayloadIndex];
      const { at } = payload;
      if (prevPayload) {
        payload.at = prevPayload.at;
      }
      const isSamePayload = dequal(prevPayload, payload);
      payload.at = at;
      if (prevPayload) this.appState[prevPayloadIndex] = payload;
      if (isSamePayload) {
        this.log("Payload matches");
        return;
      }
      if (prevPayload) {
        this.log("Payload token exists, but is different");
      } else {
        this.log("Payload token is new");
        this.appState.push(payload);
      }
      this.log("new app state... ", this.appState);
      this.batchStateUpdate();
    },
    send(payload) {
      if (!this.user) {
        return;
      }
      payload = Object.assign(payload, {
        token: this.token,
        userId: this.user.id,
        userName: this.user.display_name || this.user.name,
        // display_name is what is passed down for new sessions, people who haven't recently logged still don't have that field
        userInitials: this.user.initials,
        carrierId: this.carrierId || null,
        // undefined is not transmitted through JSON creating comparisons more brittle
        at: Date.now()
      });
      this.log("sending... ", payload);
      if (this.ready) {
        this.channel.trigger("client-hubtran:user_moved_to", payload);
        this.sendPresenceToAudit(payload);
      }
      this.pageCurrentUserIsOn = payload;
    },
    sendPresenceToAudit: function(payload) {
      console.log("sending presence info", payload, { time: /* @__PURE__ */ new Date() });
      this.waitForPresence = $.post("/api/presence", payload);
    },
    getLocationData(path) {
      this.log("getting location data for path " + path);
      let md, md1;
      if (md = path.match(/index-document-batches\/(\d+)/)) {
        return { batchId: parseInt(md[1]), path };
      }
      if (md = path.match(/loads\/(\d+)/)) {
        return { loadId: parseInt(md[1]), path };
      }
      if (md = path.match(
        /carrier_invoices_workflow\/\d+\?(?:[^?]*&)?loadId=(\d+)/
      )) {
        return { loadId: parseInt(md[1]), path };
      }
      if (md = path.match(/email\/(\d+)/)) {
        return { emailId: parseInt(md[1]), path };
      }
      if (md = path.match(/reply\/(\d+)/)) {
        return { emailId: parseInt(md[1]), path };
      }
      if (md = path.match(/factor_invoices_workflow\/batch\/(\d+)/)) {
        return { batchId: parseInt(md[1]), path };
      }
      if (md = path.match(/factor_invoices_workflow\/(\d+)/)) {
        return { factorInvoiceId: parseInt(md[1]), path };
      }
      if (md = path.match(/factor_invoices\/(\d+)/)) {
        if (md1 = path.match(/index-document-batches%2F(\d+)/)) {
          return { batchId: parseInt(md1[1]), path };
        } else {
          return { factorInvoiceId: parseInt(md[1]), path };
        }
      }
      if (md = path.match(/email_messages\/(\d+)/)) {
        return { emailId: parseInt(md[1]), path };
      }
      if (md = path.match(/verification_batch\/(\d+)/)) {
        return { debtorBatchId: parseInt(md[1]), path };
      }
      const nextReview = parseReviewPath(path);
      if (nextReview) {
        return {
          document_review: encodeDocumentReviewStartNextResponse_NextReview(nextReview),
          path
        };
      }
      return { path };
    },
    getOtherUsers(target) {
      var users = [];
      if (target.batchId) {
        users = users.concat(
          presenceService.usersOnBatch(parseInt(target.batchId))
        );
      }
      if (target.emailId) {
        users = users.concat(presenceService.usersOnEmail(target.emailId));
      }
      if (target.loadId) {
        users = users.concat(presenceService.usersOnLoad(target.loadId));
      }
      if (target.carrierId) {
        users = users.concat(presenceService.usersOnCarrier(target.carrierId));
      }
      if (target.factorInvoiceId) {
        users = users.concat(
          presenceService.usersOnFactorInvoice(target.factorInvoiceId)
        );
      }
      if (target.debtorBatchId) {
        users = users.concat(
          presenceService.usersOnDebtorBatch(target.debtorBatchId)
        );
      }
      const uniq = {};
      return users.reduce(
        (arr, { userName: name }) => {
          const hasVal = uniq[name];
          if (hasVal) return arr;
          uniq[name] = 1;
          arr.push({ name });
          return arr;
        },
        []
      );
    },
    userMovedTo(path) {
      this.log("In userMoved to", path);
      const payload = this.getLocationData(path);
      this.log("In userMoved to: payload: ", payload);
      this.send(payload);
    },
    removeTokens(tokens) {
      tokens.forEach((token) => {
        const tokenIndex = findTokenIndex(this.appState, token);
        if (tokenIndex < 0) return;
        this.appState.splice(tokenIndex, 1);
      });
      this.$this.trigger("presence_service:updated");
    },
    usersOnEmail(emailId) {
      return this.usersOnItem("emailId", emailId);
    },
    usersOnBatch(batchId) {
      return this.usersOnItem("batchId", batchId);
    },
    usersOnLoad(loadId) {
      return this.usersOnItem("loadId", loadId);
    },
    usersOnItem(key, val) {
      return this.appState.filter((state) => state[key] === val);
    },
    usersOnCarrier(carrierId) {
      return this.appState.filter(
        (state) => state.carrierId && state.carrierId === carrierId
      );
    },
    usersOnFactorInvoice(factorInvoiceId) {
      return this.usersOnItem("factorInvoiceId", factorInvoiceId);
    },
    usersOnDebtorBatch(debtorBatchId) {
      return this.usersOnItem("debtorBatchId", debtorBatchId);
    },
    didStartViewingCarrier(carrierId) {
      if (this.carrierId !== carrierId) {
        this.carrierId = carrierId;
        if (this.pageCurrentUserIsOn) {
          this.send(this.pageCurrentUserIsOn);
        }
      }
    },
    didFinishViewingCarrier() {
      this.carrierId = null;
      if (this.pageCurrentUserIsOn) {
        this.send(this.pageCurrentUserIsOn);
      }
    },
    log(message, arg) {
      if (!this.logging) {
        return;
      }
      if (arg !== void 0) {
        console.log(`Presence: ${message}`, arg);
      } else {
        console.log(`Presence: ${message}`);
      }
    }
  };
  window.theInstance = instance;
  return instance;
};
const presenceService = new PresenceService();
window.presenceService = presenceService;
export default presenceService;
